import { Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/sidebar'
import { Header } from '@/components/header'
import { Button } from '@/components/ui/button'
import { AlertTriangle, Loader2 } from 'lucide-react'
import { useAppLayout } from './AppLayout.logic'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'

export function AppLayout() {
  const { t } = useTranslation('settings')
  const { t: tc } = useTranslation('common')
  const { isPastDue, isRedirecting, handleUpdatePayment } = useAppLayout()
  const isOnline = useOnlineStatus()

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Header />
        {isPastDue && (
          <div className="flex items-center justify-between gap-4 border-b border-destructive/30 bg-destructive/10 px-4 py-2.5 lg:px-6">
            <div className="flex items-center gap-2 text-sm text-destructive">
              <AlertTriangle className="size-4 shrink-0" />
              <span>{t('billingSettings.pastDueBanner')}</span>
            </div>
            <Button
              size="sm"
              variant="destructive"
              onClick={handleUpdatePayment}
              disabled={isRedirecting}
              className="shrink-0"
            >
              {isRedirecting ? (
                <Loader2 className="size-3 animate-spin" />
              ) : (
                t('billingSettings.updatePayment')
              )}
            </Button>
          </div>
        )}
        {!isOnline && (
          <div className="flex items-center gap-2 border-b border-yellow-400/30 bg-yellow-400/10 px-4 py-2.5 text-sm text-yellow-700 dark:text-yellow-400 lg:px-6">
            <AlertTriangle className="size-4 shrink-0" />
            <span>{tc('offlineBanner')}</span>
          </div>
        )}
        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}
